import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Box, styled } from '@mui/material';

export const ButtonsContainer = styled(Box)`
  position: fixed;
  right: 10px;
  top: 22px;
`;

export const StyledWarningIcon = styled(WarningAmberOutlinedIcon)(
  ({ theme }) => `
  color:${theme.palette.brand?.yellow};
`,
);
